import { createFileRoute, Link } from '@tanstack/react-router';
import { ArrowLeftIcon } from 'lucide-react';
import type { JSX } from 'react';

import { SpendingDashboard } from '@/features/developers/SpendingDashboard.js';
import { ensureDeveloperEnabled } from '@/features/developers/guard.js';
import { globalSpendingQueryOptions } from '@/lib/api/developers.js';

export const Route = createFileRoute('/developer_/spending')({
  component: GlobalSpendingPage,
  beforeLoad: () => ensureDeveloperEnabled(),
});

function GlobalSpendingPage(): JSX.Element {
  return (
    <div className="flex w-full flex-col gap-5 px-4 py-6 sm:px-6 lg:px-8">
      <div className="flex min-w-0 items-center gap-2">
        <Link
          to="/developer"
          className="flex size-8 shrink-0 items-center justify-center rounded-lg text-muted-foreground hover:bg-muted hover:text-foreground"
          aria-label="Back to Developer"
        >
          <ArrowLeftIcon className="size-4" aria-hidden />
        </Link>
        <h1 className="truncate font-heading text-xl font-bold tracking-tight">
          Developer spending
        </h1>
      </div>
      <SpendingDashboard
        global
        queryOptionsFor={(period) => globalSpendingQueryOptions(period)}
      />
    </div>
  );
}
